module.exports = __webpack_public_path__ + "static/mo02-4e7d23a3dc861b09c4b34456801a093b.png";